import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
  selectIsLoggedIn,
  selectCurrentUserFetchedAtleastOnce,
  selectHasCurrentUserAcceptedCurrentTermsAndPrivacy,
} from 'store/features/auth/selectors';

import Consent from 'ui/auth/consent';

function mapStateToProps(state) {
  return {
    loggedIn: selectIsLoggedIn(state),
    currentUserFetchedAtleastOnce: selectCurrentUserFetchedAtleastOnce(state),
    currentTcAndPrivacyAcceptedByCurrentUser: selectHasCurrentUserAcceptedCurrentTermsAndPrivacy(
      state
    ),
  };
}

const AuthenticatedConsentCheck = WrappedComponent => {
  class Wrapper extends React.Component {
    render() {
      const {
        loggedIn,
        currentUserFetchedAtleastOnce,
        currentUserApproved,
        location,
        currentTcAndPrivacyAcceptedByCurrentUser,
        ...passThrough
      } = this.props;

      if (loggedIn) {
        if (currentUserFetchedAtleastOnce) {
          if (!currentTcAndPrivacyAcceptedByCurrentUser) return <Consent />;
        }
      }

      return <WrappedComponent {...passThrough} />;
    }
  }

  Wrapper.displayName = 'AuthenticatedConsentCheck';

  return withRouter(connect(mapStateToProps)(Wrapper));
};

export default AuthenticatedConsentCheck;



// WEBPACK FOOTER //
// ./src/ui/common/auth/authenticated-consent-check.js